// Page /search-metrics : métriques de la recherche publique, réservée au palier
// administrateur (feature « search-metrics », exemptée du wildcard read : le rôle
// viewer ne la voit pas). Latence en millisecondes jour par jour (mêmes chiffres
// que la page Metrics) et top des termes cherchés par les visiteurs sur sept
// jours glissants.
import React from "react";
import { useSearchMetrics } from "../hooks/useSearchMetrics";
import SearchUsageSection from "../Components/SearchUsageSection";
import SearchTermsSection from "../Components/SearchTermsSection";

const SearchMetrics: React.FC = () => {
	const { metrics, loading, error } = useSearchMetrics(14);

	return (
		<div className="space-y-6 p-6">
			<header>
				<h1 className="text-2xl font-bold text-slate-900">Métriques de recherche</h1>
				<p className="mt-1 text-sm text-slate-500">
					Latence et termes de la recherche publique. Page réservée aux administrateurs :
					les termes tapés par les visiteurs ne sont montrés nulle part ailleurs.
				</p>
			</header>

			<SearchUsageSection
				usage={metrics ? { days: metrics.days, today: metrics.today } : null}
				loading={loading}
				error={error}
			/>

			<SearchTermsSection
				terms={metrics?.topTerms ?? []}
				windowDays={metrics?.termWindowDays ?? 7}
				loading={loading}
				error={error}
			/>
		</div>
	);
};

export default SearchMetrics;
